import { useContext } from 'react';
import CustomerForm from '../../../ui-components/customer-form/CustomerForm';
import { bookingState } from '../client-state/booking-state-context';
import { put } from '../../../Utils/fetch';
import useLocalize from '../../../Hooks/useLocalize';
import { bookingStepDependencies } from '../index';
import useBookingTracking from '../../../Hooks/useBookingTracking';
import { loadingReducerActionTypes } from '../../../redusers/loading-reducer';
import { customerReducerActionTypes } from '../../../redusers/customer-reducer';
import { errorReducerActionTypes } from '../../../redusers/error-reducer';
import useBookingMinimalShop from '../server-data/use-booking-minimal-shop';
import useBookingChangeStep from '../../../Hooks/use-booking-change-step';

const CustomerFormWithDataVariant = () => {
  const { data: minimalShop } = useBookingMinimalShop();
  const { state, dispatch } = useContext(bookingState);
  const localize = useLocalize();
  const changeStep = useBookingChangeStep(bookingStepDependencies);
  const track = useBookingTracking();

  const updateCustomer = async () => {
    try {
      dispatch({ type: loadingReducerActionTypes.CUSTOMER, payload: true });
      const updatedCustomer = await put(
        `Customers/${state.booking.customerId}/updateCustomerAlt`,
        state.customer.customer
      );

      return dispatch({
        type: customerReducerActionTypes.UPDATE_CUSTOMER,
        payload: updatedCustomer,
      });
    } catch (error) {
      throw error;
    }
  };

  return (
    <CustomerForm
      customer={state.customer.customer}
      onChange={(event, country) =>
        dispatch({
          type: customerReducerActionTypes.UPDATE_CUSTOMER,
          payload: {
            ...state.customer.customer,
            [event.target.name]: event.target.value,
            ...(country && { address: { country: country } }),
          },
        })
      }
      onFormValid={(formValid) => {
        dispatch({
          type: customerReducerActionTypes.UPDATE_FORM_VALID,
          payload: formValid,
        });

        if (formValid) {
          track({ type: 'CUSTOMER_FORM_FILLED' });
        }
      }}
      onSubmit={async () => {
        try {
          dispatch({ type: errorReducerActionTypes.BOOKING_CREATE, payload: false });
          await updateCustomer();

          changeStep(4);

          track({ type: 'CHECKOUT', product: state.booking, step: 1 });
          track({ type: 'ADD_SHIPPING_INFO', product: state.booking });
        } catch (error) {
          dispatch({
            type: errorReducerActionTypes.BOOKING_CREATE,
            payload: 'UnknownError',
          });
        }
      }}
      errors={{
        booking: state.errors.booking
          ? localize(`error.${state.errors.booking}`, state.errors.booking)
          : undefined,
        customerForm: state.errors.customerForm ?? '',
      }}
      loading={state.loading.customer}
      shopCountry={minimalShop?.country}
      showButton={false}
    />
  );
};

export default CustomerFormWithDataVariant;
